import { deburr, get, isNil } from "lodash";
import { VALIDATORS } from "utils/validation-rules";
import { slotPathOf, slotsOfStep } from "./recommendation-guide";
import { SLOT_TYPES } from "./workshop-view";

const CHECKED_VALIDATORS = [VALIDATORS.NIR, VALIDATORS.IBAN, VALIDATORS.BIC];

const TERMS = {
  [VALIDATORS.NIR]: ["securite sociale", "secu sociale", "numero secu", "nir"],
  [VALIDATORS.IBAN]: ["iban"],
  [VALIDATORS.BIC]: ["bic", "swift"],
};

const wordsOf = (text) =>
  ` ${deburr(String(isNil(text) ? "" : text))
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim()} `;

const validatorOfRules = (rules) =>
  (rules || [])
    .map((rule) => get(rule, "validator"))
    .find((validator) => CHECKED_VALIDATORS.includes(validator)) || null;

export const checkedFieldsOf = (variables) =>
  (variables || [])
    .map((variable) => ({
      path: variable.field,
      accessor: variable.accessor,
      label: variable.label || variable.field,
      validator: validatorOfRules(variable.defaultRules),
    }))
    .filter((field) => !isNil(field.validator));

export const validatorOfText = (...texts) => {
  for (const text of texts) {
    const words = wordsOf(text);
    if (!words.trim()) continue;
    const found = CHECKED_VALIDATORS.find((validator) =>
      TERMS[validator].some((term) => words.includes(` ${term} `)),
    );
    if (!isNil(found)) return found;
  }
  return null;
};

export const checkedFieldOf = (checkedFields, path) =>
  (checkedFields || []).find((field) => field.path === path) || null;

export const lookalikeValidator = (slot, path) =>
  validatorOfText(path, get(slot, "label"));

export const fieldsForValidator = (checkedFields, validator) =>
  (checkedFields || []).filter((field) => field.validator === validator);

const formRuleOf = (node, field) =>
  validatorOfRules(
    get(
      (get(node, "data.formDefinition.fields") || []).find((item) =>
        [field.path, field.accessor].some(
          (path) =>
            !isNil(path) && (item.accessor === path || item.key === path),
        ),
      ),
      "rules",
    ),
  );

const isInputSlot = (slot) => get(slot, "type") === SLOT_TYPES.INPUT;

export const checkedFieldIssues = (node, checkedFields) => {
  if (!get(checkedFields, "length")) return [];
  return slotsOfStep(node)
    .filter(isInputSlot)
    .map((slot) => {
      const path = slotPathOf(slot);
      const field = checkedFieldOf(checkedFields, path);
      if (!isNil(field))
        return formRuleOf(node, field) === field.validator
          ? null
          : { kind: "NO_CHECK", slot, field };
      const validator = lookalikeValidator(slot, path);
      if (isNil(validator)) return null;
      return {
        kind: "NOT_LINKED",
        slot,
        fields: fieldsForValidator(checkedFields, validator),
      };
    })
    .filter(Boolean);
};
